import React from "react";
import { FiCheck } from "react-icons/fi";
import { useOnboarding } from "../OnboardingContext";
import { useOnboardingSheet } from "../OnboardingSheet";
import "./StepSuccess.css";

export default function StepSuccess() {
  const { requestCloseTo } = useOnboardingSheet();
  const { isEditMode } = useOnboarding();

  return (
    <div className="onboarding-success">
      <div className="onboarding-success__card">
        <div className="onboarding-success__icon-wrap" aria-hidden>
          <FiCheck className="onboarding-success__icon" />
        </div>
        <h1 className="onboarding-success__title">
          {isEditMode ? "Profile updated successfully" : "Account created successfully"}
        </h1>
        <p className="onboarding-success__subtitle">
          {isEditMode
            ? "Your changes are saved and visible on your profile."
            : "Your profile is live with the details you added. You can edit anything later."}
        </p>
        <button
          type="button"
          className="onboarding-success__cta btn-primary"
          onClick={() => requestCloseTo("/profile-details")}
        >
          {isEditMode ? "Back to profile" : "View my profile"}
        </button>
      </div>
    </div>
  );
}
